import { ParticipantRegistrationMetric } from 'app/library/participant-registration-metric/models/participant-registration-metric.model';
import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { Module } from './module.model';

export class ModuleStateModel extends EntityStateModel<Module> {
    participantScormRegistrationMetrics?: ParticipantRegistrationMetric;
}
